import Vue from 'vue';
import VueRouter from 'vue-router';

import Page404 from '@/views/NotFound404.vue';
import Dashboard from '@/views/Dashboard.vue';
import Auth from '@/views/Auth.vue';
import { fbAuth } from '../firebase';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Auth',
    component: Auth,
    meta: { requiresAuth: false },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '*',
    name: 'Not Found',
    component: Page404,
    meta: { requiresAuth: false },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // If route required authentication
  if (requiresAuth) {
    // Load user
    fbAuth.onAuthStateChanged((user) => {
      // If user obj does not exist --> redirect to login page
      if (!user || !window.sessionStorage.vuex) {
        next({ name: 'Auth' });
      } else {
        /*
        store.commit('user/SET_USER', user);
        user.getIdToken().then((token) => {
          store.commit('user/SET_TOKEN', token);
        });
        */
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
